import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, GeoJSON ,Popup,Tooltip} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import chroma from "chroma-js"; 
import ReactDOMServer from 'react-dom/server';
//import geojsonData from '../data/thailand-provinces.geojson'; // Adjust the path
//import {geojson} from './test2';

const CompleteByProvince = () => {
    const geojsonData = require('../data/thailand-provinces-v2.json');
    const [mapData, setMapData] = useState(geojsonData);
    const [center, setCenter] = useState([13.7563, 100.5018]); // Center coordinates (adjust as needed)
    const [data, setData] = useState(null);
    console.log(geojsonData);
    useEffect(() => {
        fetch("https://malaria-api.ddc-malaria.org/mhealth/getChartOverallCompleteByProvinceToday/fs_year")
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then((apiData) => {
            const transformedData = apiData?.overall_plan_complete_by_province?.map(
              (provinceData) => {
                const { province_id, total_plan, total_done } = provinceData;
                const percentComplete =  Math.round((total_done / total_plan) * 100) || 0;
    
                return {
                  id: province_id,
                  completionPercentage: percentComplete,
                };
              }
            ) ?? [];
    
            setData(transformedData);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
            // Handle the error, e.g., display an error message to the user
          });
      }, []);

    const geoJSONStyle = {
        color: '#4a83ec',
        weight: 2,
        opacity: 0.65
    };

        const colorScale = chroma
    .scale(["red", "green"])
    .domain([0, 100]); 

        
    return (
      <MapContainer center={center} zoom={5} style={{ height: "800px" }}>
          <TileLayer
                //attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                // url="https://tiles.stadiamaps.com/tiles/stamen_toner/{z}/{x}/{y}{r}.png"
            />
          <GeoJSON
              data={mapData}
              //onEachFeature={onEachFeature}
              //onEachFeature={data ? onEachFeature : null} 
              style={(feature) => {
                  const provinceId = feature.properties.ADM1_PCODE; // Get the province ID from GeoJSON
                  const provinceData = data?.find(item => item.id === provinceId);
                  //const totalPlan = provinceData?.total_plan || 0; 
                  //const completionPercentage = totalPlan === 0 ? 0 : (provinceData?.completionPercentage || 0);
                  const completionPercentage = provinceData?.completionPercentage || 0; // Default to 0 if not found
                  const fillColor = colorScale(completionPercentage);

                  return {
                      ...geoJSONStyle, // Keep your default style
                      fillColor: fillColor
                  };
              }}
          />
      </MapContainer>
  );
}

export default CompleteByProvince;
